import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { useTranslation } from 'react-i18next';
type CaptureButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  variant: 'default' | 'round' | 'stop';
};
const CaptureButton = t0 => {
  const $ = _c(13);
  const {
    onClick,
    disabled: t1,
    variant
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "document-flow.components.camera"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[1] !== disabled || $[2] !== onClick || $[3] !== t || $[4] !== variant) {
    t3 = variant === "default" && <Button fullWidth={true} aria-disabled={disabled} data-disabled={disabled} onClick={onClick} disabled={disabled} size="large" data-dd-action-name="doc:take-photo">{t(_temp)}</Button>;
    $[1] = disabled;
    $[2] = onClick;
    $[3] = t;
    $[4] = variant;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== disabled || $[7] !== onClick || $[8] !== variant) {
    t4 = (variant === "round" || variant === "stop") && <div role="button" tabIndex={0} aria-disabled={disabled} data-disabled={disabled} onClick={onClick} onKeyDown={e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        onClick();
      }
    }} className={cx("flex justify-center items-center bg-transparent rounded-full absolute bottom-4 cursor-pointer w-[72px] h-[72px]", "border-[6px] border-solid border-white", disabled && "border-senary pointer-events-none")} data-dd-action-name="doc:take-photo">{variant === "round" ? <button type="button" aria-disabled={disabled} data-disabled={disabled} className={cx("bg-white border-none rounded-full shadow-md w-14 h-14", disabled && "bg-senary", "active:bg-white/80")} data-dd-action-name="doc:take-photo" /> : <button type="button" className="w-6 h-6 bg-white border-none rounded-sm shadow-md" />}</div>;
    $[6] = disabled;
    $[7] = onClick;
    $[8] = variant;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
};
export default CaptureButton;
function _temp($) {
  return $.take;
}